import React, { useContext, useEffect } from 'react';

import { StyledCtaButton } from './CtaButton.style';
import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { StyleContext } from '../../utils/contexts/style.context';

export interface Props {
  backgroundColor: string | null;
  innerHTML: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  dataTemplateConfig: string;
  dataTemplateType?: string;
  className?: string;
  addEditableBlock?: (block: BlockInfoType) => void;
  removeEditableBlock?: (configPath: string) => void;
  displayName: string;
  isEdition: boolean | undefined;
  testId?: string;
  disabled?: boolean;
}

export const CtaButton: React.FunctionComponent<Props> = ({
  addEditableBlock,
  removeEditableBlock,
  className,
  backgroundColor,
  innerHTML,
  onClick,
  dataTemplateConfig,
  displayName,
  isEdition,
  testId,
  dataTemplateType = 'button',
  disabled,
} : Props) => {
  const commonStyle = useContext(StyleContext);

  useEffect(
    () => {
      if (addEditableBlock) {
        addEditableBlock({
          blockType: dataTemplateType,
          configPath: dataTemplateConfig,
          label: displayName,
        });
      }
      return () => {
        if (removeEditableBlock) {
          removeEditableBlock(dataTemplateConfig);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataTemplateConfig]
  );

  const borderRadius = commonStyle.style === null
    ? '10vh'
    : commonStyle.style.button.borderRadius;

  return (
    <StyledCtaButton
      disabled={disabled}
      data-template-type={dataTemplateType}
      data-display-name={displayName}
      data-config-path={dataTemplateConfig}
      className={className}
      backgroundColor={backgroundColor}
      dangerouslySetInnerHTML={{ __html: innerHTML }}
      onClick={disabled === true
        ? undefined
        : onClick}
      isEdition={isEdition}
      data-testid={testId}
      borderRadius={borderRadius}
    />
  );
};
